export const COPIED_TIMEOUT_MS = 1500;
